import React, { useEffect } from 'react';
import { Link } from "react-router-dom";
import Header from'../Component/Header';
const Withdrawals = () => { 
    useEffect(() => {
        document.title = ' Withdrawals - Sacread Heart Kharagpur';  
    }, []); 
  return (
     <>
     <Header/>
       <div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  Academic</li>
                 <li>Withdrawals</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1>Withdrawals</h1>
                    </div>
                </div>
                <div className="row">
                     <div className="col-12"> 
                        <ul className="list">
                          <li> In case a student has to be withdrawn before the end of the academic year, prior to the withdrawal a month's notice must be given in writing and the full Academic year's fees needs to be cleared.</li> 
                          <li>Should a pupil be removed from the school, no certificate will be granted until all dues to the school have been paid.</li>
                          <li> Application for a Transfer Certificate need to be made in writing to the principal. This must be collected from the School Office and signed for and a prescribed fees is to be paid. Duplicate copies of Transfer certificate are ordinarily not issued.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default Withdrawals

